
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _MatrixManagerBase from '../../moreCore/UI/Matrix/_MatrixManagerBase';


interface instrument extends more.EntityAPIResultExtendedGDisp1 {

}

interface instrumentBox extends more.EntityAPIResultExtendedGDisp1 {

}

interface instrumentBoxAssignment {

}
class xyMatrixInstruments extends compose(_MatrixManagerBase<instrumentBox, instrument, instrumentBoxAssignment>) {

   

    private _checkCellClickAllowed(x: instrumentBox, y: instrument, z: instrumentBoxAssignment): boolean {
        
        return true;
    }

    private _getConfiguration(): Object {
        let id = this.getUrlParameterValue("projectID");
        return {
            projectID: id
        };
    }

    private _onClickX(ID: string, element: instrumentBox) {
        console.debug(this.id + " open X", ID, element);
    //    EntityHelpers.openEntityView({
    //        entityClass: element.Classname,
    //        entityId: element.ID,
    //        label: element.gDisp_1
    //    });
    }

    private _onClickY(ID: string, element: instrument) {
        console.debug(this.id + " open Y", ID, element);
    //    EntityHelpers.openEntityView({
    //        entityClass: element.Classname,
    //        entityId: element.ID,
    //        label: element.gDisp_1
    //    });
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles("InstrumentMatrix XY");

        this.setup({
            configurationAPI: "Webtool_API_InstrumentBoxMatrixXY__LoadConfiguration",
            contentAPI: "Webtool_API_InstrumentBoxMatrixXY__LoadGridContent",
            configurationParams: this._getConfiguration(),
            saveAPI: "Webtool_API_InstrumentBoxMatrixXY__CommitContent",
            cellClickCheck: lang.hitch(this, this._checkCellClickAllowed),
            xElementClickCallback: lang.hitch(this, this._onClickX),
            yElementClickCallback: lang.hitch(this, this._onClickY)
        });
    }
}

export default mdsWidget(xyMatrixInstruments);